<template>
  <div>
    <div class="uk-section uk-section-small">
      <div class="uk-grid-small" uk-grid>
        <div class="uk-width-1-1">
          <h3>New user - {{ user.given_name + '' + user.family_name }}</h3>
        </div>
        <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l uk-width-1-2@l">
          <form class="uk-form-horizontal" v-on:submit.prevent="newUser">
            <div class="uk-margin">
              <div class="uk-inline">
                <label for="given_name" class="uk-form-label">Given Name</label>
                <div class="uk-form-controls">
                  <input id="given_name" type="text" class="uk-input" v-model="user.given_name" placeholder="Enter the given name" required>
                </div>
              </div>
            </div>
            <div class="uk-margin">
              <div class="uk-inline">
                <label for="family_name" class="uk-form-label">Family Name</label>
                <div class="uk-form-controls">
                  <input id="family_name" type="text" class="uk-input" v-model="user.family_name" placeholder="Enter the family name" required>
                </div>
              </div>
            </div>
            <div class="uk-margin">
              <div class="uk-inline">
                <label for="email" class="uk-form-label">Email</label>
                <div class="uk-form-controls">
                  <input id="email" type="email" class="uk-input" v-model="user.email" placeholder="Enter the email" required>
                </div>
              </div>
            </div>
            <div class="uk-margin">
              <div class="uk-inline">
                <label for="password" class="uk-form-label">*Password</label>
                <div class="uk-form-controls">
                  <input id="password" type="text" class="uk-input" minlength="3" v-model="user.password" placeholder="Enter the password" required>
                </div>
              </div>
            </div>
            <div class="uk-margin" v-if="user.password.length > 3">
              <div class="uk-inline">
                <label for="password_verify" class="uk-form-label">Verify Password</label>
                <div class="uk-form-controls">
                  <input id="password_verify" type="text" class="uk-input" minlength="3" v-model="user.password_check" placeholder="Enter the password" required>
                </div>
              </div>
            </div>
            <div class="uk-margin">
              <div class="uk-inline">
                <button class="uk-button uk-button-primary">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "New",
    data() {
      return {
        user: {
          given_name: '',
          family_name: '',
          email: null,
          password: '',
          password_check: ''
        }
      }
    },
    methods: {
      newUser() {
        const self = this;

        if (self.user.password !== self.user.password_check) {
          self.$uikit.notification({
            message: 'Passwords don\'t match',
            status: 'warning',
            position: 'top-center',
            timeout: 2500,
          });
          return false;
        }

        self.$request().post('/user', {
            email: self.user.email,
            given_name: self.user.given_name,
            family_name: self.user.family_name,
            password: self.user.password,
          }).then(r => {
            self.$uikit().notification({
              message: 'The user was successfully created.',
              status: 'success',
              position: 'top-center',
              timeout: 2500,
            });
            setTimeout(function() {
              self.$router.push({name: 'User'})
            }, 2500);
          }).catch(e => {
            self.$uikit().notification({
              message: 'Something went wrong! Please try again later.',
              status: 'danger',
              position: 'top-center',
              timeout: 5000,
            });
          });
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/New.vue